// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from "./client";
import { client } from "./client.gen";
import type {
  ActivationChecklistDismissData,
  ActivationChecklistDismissErrors,
  ActivationChecklistDismissResponses,
  ActivationChecklistShowData,
  ActivationChecklistShowErrors,
  ActivationChecklistShowResponses,
  BranchesNodesStyleData,
  BranchesNodesStyleErrors,
  BranchesNodesStyleResponses,
  CitiesIndexData,
  CitiesIndexErrors,
  CitiesIndexResponses,
  CountriesIndexData,
  CountriesIndexErrors,
  CountriesIndexResponses,
  DistributionChartData,
  DistributionChartErrors,
  DistributionChartResponses,
  DistrictsIndexData,
  DistrictsIndexErrors,
  DistrictsIndexResponses,
  DocumentsNotificationRecipientsCountData,
  DocumentsNotificationRecipientsCountErrors,
  DocumentsNotificationRecipientsCountResponses,
  DocumentsShareLinkStoreData,
  DocumentsShareLinkStoreErrors,
  DocumentsShareLinkStoreResponses,
  FamilyLinkSharesStoreData,
  FamilyLinkSharesStoreErrors,
  FamilyLinkSharesStoreResponses,
  GalleryPhotosShareLinkStoreData,
  GalleryPhotosShareLinkStoreErrors,
  GalleryPhotosShareLinkStoreResponses,
  MarriageChildrenIndexData,
  MarriageChildrenIndexErrors,
  MarriageChildrenIndexResponses,
  MobileSearchTenantsData,
  MobileSearchTenantsErrors,
  MobileSearchTenantsResponses,
  NodeExcelExportsStartData,
  NodeExcelExportsStartErrors,
  NodeExcelExportsStartResponses,
  NodeFavoritesDestroyData,
  NodeFavoritesDestroyErrors,
  NodeFavoritesDestroyResponses,
  NodeFavoritesIndexData,
  NodeFavoritesIndexErrors,
  NodeFavoritesIndexResponses,
  NodeFavoritesStoreData,
  NodeFavoritesStoreErrors,
  NodeFavoritesStoreResponses,
  NodePackageOffersExposuresStoreData,
  NodePackageOffersExposuresStoreErrors,
  NodePackageOffersExposuresStoreResponses,
  NodesActivitiesData,
  NodesActivitiesErrors,
  NodesActivitiesResponses,
  NodesContentData,
  NodesContentErrors,
  NodesContentResponses,
  NodesFilterIndexData,
  NodesFilterIndexErrors,
  NodesFilterIndexResponses,
  NodesGalleryPhotosData,
  NodesGalleryPhotosErrors,
  NodesGalleryPhotosResponses,
  NodesLineageSplicePreviewData,
  NodesLineageSplicePreviewErrors,
  NodesLineageSplicePreviewResponses,
  NodesLineSummaryData,
  NodesLineSummaryErrors,
  NodesLineSummaryResponses,
  NodesMakeRootPreviewData,
  NodesMakeRootPreviewErrors,
  NodesMakeRootPreviewResponses,
  NodesMarriageChildrenIndexData,
  NodesMarriageChildrenIndexErrors,
  NodesMarriageChildrenIndexResponses,
  NodesOrderData,
  NodesOrderErrors,
  NodesOrderResponses,
  NodesOtherParentChildrenData,
  NodesOtherParentChildrenErrors,
  NodesOtherParentChildrenResponses,
  NodesSearchExplainedData,
  NodesSearchExplainedErrors,
  NodesSearchExplainedResponses,
  NodesShowData,
  NodesShowErrors,
  NodesShowResponses,
  NotificationCampaignsRecipientsCountData,
  NotificationCampaignsRecipientsCountErrors,
  NotificationCampaignsRecipientsCountResponses,
  NotificationsFeedData,
  NotificationsFeedErrors,
  NotificationsFeedResponses,
  NotificationsMarkAllReadData,
  NotificationsMarkAllReadErrors,
  NotificationsMarkAllReadResponses,
  NotificationsReadData,
  NotificationsReadErrors,
  NotificationsReadResponses,
  NotificationsUnreadCountData,
  NotificationsUnreadCountErrors,
  NotificationsUnreadCountResponses,
  PendingRequestsCountData,
  PendingRequestsCountErrors,
  PendingRequestsCountResponses,
  PostsNotificationRecipientsCountData,
  PostsNotificationRecipientsCountErrors,
  PostsNotificationRecipientsCountResponses,
  RelationshipsChildrenStoreData,
  RelationshipsChildrenStoreErrors,
  RelationshipsChildrenStoreResponses,
  RelationshipsIndexData,
  RelationshipsIndexErrors,
  RelationshipsIndexResponses,
  StatisticsPeopleData,
  StatisticsPeopleErrors,
  StatisticsPeopleResponses,
  TestimonialAsksDestroyData,
  TestimonialAsksDestroyErrors,
  TestimonialAsksDestroyResponses,
  TestimonialAsksStoreData,
  TestimonialAsksStoreErrors,
  TestimonialAsksStoreResponses,
  TestimonialShowData,
  TestimonialShowErrors,
  TestimonialShowResponses,
  TestimonialsStoreData,
  TestimonialsStoreErrors,
  TestimonialsStoreResponses,
  TestimonialWithdrawalDestroyData,
  TestimonialWithdrawalDestroyErrors,
  TestimonialWithdrawalDestroyResponses,
  TestimonialWithdrawalStoreData,
  TestimonialWithdrawalStoreErrors,
  TestimonialWithdrawalStoreResponses,
  TreePdfExportStartData,
  TreePdfExportStartErrors,
  TreePdfExportStartResponses,
  TreePdfExportStatusData,
  TreePdfExportStatusErrors,
  TreePdfExportStatusResponses,
  UserInvitesDestroyData,
  UserInvitesDestroyErrors,
  UserInvitesDestroyResponses,
  UserInvitesIndexData,
  UserInvitesIndexErrors,
  UserInvitesIndexResponses,
  UserInvitesResendData,
  UserInvitesResendErrors,
  UserInvitesResendResponses,
  UserInvitesStoreData,
  UserInvitesStoreErrors,
  UserInvitesStoreResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export const marriageChildrenIndex = <ThrowOnError extends boolean = true>(
  options?: Options<MarriageChildrenIndexData, ThrowOnError>,
): RequestResult<MarriageChildrenIndexResponses, MarriageChildrenIndexErrors, ThrowOnError> =>
  (options?.client ?? client).get<MarriageChildrenIndexResponses, MarriageChildrenIndexErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/marriage-children",
    ...options,
  });

export const citiesIndex = <ThrowOnError extends boolean = true>(
  options?: Options<CitiesIndexData, ThrowOnError>,
): RequestResult<CitiesIndexResponses, CitiesIndexErrors, ThrowOnError> =>
  (options?.client ?? client).get<CitiesIndexResponses, CitiesIndexErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/cities",
    ...options,
  });

export const postsNotificationRecipientsCount = <ThrowOnError extends boolean = true>(
  options?: Options<PostsNotificationRecipientsCountData, ThrowOnError>,
): RequestResult<PostsNotificationRecipientsCountResponses, PostsNotificationRecipientsCountErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    PostsNotificationRecipientsCountResponses,
    PostsNotificationRecipientsCountErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/user/posts/notification-recipients-count",
    ...options,
  });

export const documentsNotificationRecipientsCount = <ThrowOnError extends boolean = true>(
  options?: Options<DocumentsNotificationRecipientsCountData, ThrowOnError>,
): RequestResult<
  DocumentsNotificationRecipientsCountResponses,
  DocumentsNotificationRecipientsCountErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    DocumentsNotificationRecipientsCountResponses,
    DocumentsNotificationRecipientsCountErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/user/documents/notification-recipients-count",
    ...options,
  });

export const countriesIndex = <ThrowOnError extends boolean = true>(
  options?: Options<CountriesIndexData, ThrowOnError>,
): RequestResult<CountriesIndexResponses, CountriesIndexErrors, ThrowOnError> =>
  (options?.client ?? client).get<CountriesIndexResponses, CountriesIndexErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/countries",
    ...options,
  });

export const activationChecklistDismiss = <ThrowOnError extends boolean = true>(
  options?: Options<ActivationChecklistDismissData, ThrowOnError>,
): RequestResult<ActivationChecklistDismissResponses, ActivationChecklistDismissErrors, ThrowOnError> =>
  (options?.client ?? client).post<ActivationChecklistDismissResponses, ActivationChecklistDismissErrors, ThrowOnError>(
    { url: "/user/activation-checklist/dismiss", ...options },
  );

export const districtsIndex = <ThrowOnError extends boolean = true>(
  options: Options<DistrictsIndexData, ThrowOnError>,
): RequestResult<DistrictsIndexResponses, DistrictsIndexErrors, ThrowOnError> =>
  (options.client ?? client).get<DistrictsIndexResponses, DistrictsIndexErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/districts",
    ...options,
  });

export const documentsShareLinkStore = <ThrowOnError extends boolean = true>(
  options: Options<DocumentsShareLinkStoreData, ThrowOnError>,
): RequestResult<DocumentsShareLinkStoreResponses, DocumentsShareLinkStoreErrors, ThrowOnError> =>
  (options.client ?? client).post<DocumentsShareLinkStoreResponses, DocumentsShareLinkStoreErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/documents/{document}/share-link",
    ...options,
  });

export const galleryPhotosShareLinkStore = <ThrowOnError extends boolean = true>(
  options: Options<GalleryPhotosShareLinkStoreData, ThrowOnError>,
): RequestResult<GalleryPhotosShareLinkStoreResponses, GalleryPhotosShareLinkStoreErrors, ThrowOnError> =>
  (options.client ?? client).post<
    GalleryPhotosShareLinkStoreResponses,
    GalleryPhotosShareLinkStoreErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/user/gallery/photos/{galleryPhoto}/share-link",
    ...options,
  });

export const nodesMarriageChildrenIndex = <ThrowOnError extends boolean = true>(
  options: Options<NodesMarriageChildrenIndexData, ThrowOnError>,
): RequestResult<NodesMarriageChildrenIndexResponses, NodesMarriageChildrenIndexErrors, ThrowOnError> =>
  (options.client ?? client).get<NodesMarriageChildrenIndexResponses, NodesMarriageChildrenIndexErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/nodes/{node}/marriage-children",
    ...options,
  });

export const relationshipsChildrenStore = <ThrowOnError extends boolean = true>(
  options: Options<RelationshipsChildrenStoreData, ThrowOnError>,
): RequestResult<RelationshipsChildrenStoreResponses, RelationshipsChildrenStoreErrors, ThrowOnError> =>
  (options.client ?? client).post<RelationshipsChildrenStoreResponses, RelationshipsChildrenStoreErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/relationships/{relationship}/children",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const nodesShow = <ThrowOnError extends boolean = true>(
  options: Options<NodesShowData, ThrowOnError>,
): RequestResult<NodesShowResponses, NodesShowErrors, ThrowOnError> =>
  (options.client ?? client).get<NodesShowResponses, NodesShowErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/nodes/{node}",
    ...options,
  });

export const nodesActivities = <ThrowOnError extends boolean = true>(
  options: Options<NodesActivitiesData, ThrowOnError>,
): RequestResult<NodesActivitiesResponses, NodesActivitiesErrors, ThrowOnError> =>
  (options.client ?? client).get<NodesActivitiesResponses, NodesActivitiesErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/nodes/{node}/activities",
    ...options,
  });

export const nodesContent = <ThrowOnError extends boolean = true>(
  options: Options<NodesContentData, ThrowOnError>,
): RequestResult<NodesContentResponses, NodesContentErrors, ThrowOnError> =>
  (options.client ?? client).get<NodesContentResponses, NodesContentErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/nodes/{node}/content",
    ...options,
  });

export const nodeExcelExportsStart = <ThrowOnError extends boolean = true>(
  options?: Options<NodeExcelExportsStartData, ThrowOnError>,
): RequestResult<NodeExcelExportsStartResponses, NodeExcelExportsStartErrors, ThrowOnError> =>
  (options?.client ?? client).post<NodeExcelExportsStartResponses, NodeExcelExportsStartErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/node-excel-exports",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

export const nodeFavoritesIndex = <ThrowOnError extends boolean = true>(
  options?: Options<NodeFavoritesIndexData, ThrowOnError>,
): RequestResult<NodeFavoritesIndexResponses, NodeFavoritesIndexErrors, ThrowOnError> =>
  (options?.client ?? client).get<NodeFavoritesIndexResponses, NodeFavoritesIndexErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/node-favorites",
    ...options,
  });

export const nodeFavoritesDestroy = <ThrowOnError extends boolean = true>(
  options: Options<NodeFavoritesDestroyData, ThrowOnError>,
): RequestResult<NodeFavoritesDestroyResponses, NodeFavoritesDestroyErrors, ThrowOnError> =>
  (options.client ?? client).delete<NodeFavoritesDestroyResponses, NodeFavoritesDestroyErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/node-favorites/{node}",
    ...options,
  });

export const nodeFavoritesStore = <ThrowOnError extends boolean = true>(
  options: Options<NodeFavoritesStoreData, ThrowOnError>,
): RequestResult<NodeFavoritesStoreResponses, NodeFavoritesStoreErrors, ThrowOnError> =>
  (options.client ?? client).post<NodeFavoritesStoreResponses, NodeFavoritesStoreErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/node-favorites/{node}",
    ...options,
  });

export const nodesFilterIndex = <ThrowOnError extends boolean = true>(
  options: Options<NodesFilterIndexData, ThrowOnError>,
): RequestResult<NodesFilterIndexResponses, NodesFilterIndexErrors, ThrowOnError> =>
  (options.client ?? client).get<NodesFilterIndexResponses, NodesFilterIndexErrors, ThrowOnError>({
    responseType: "json",
    url: "/nodes/user/filter",
    ...options,
  });

export const nodesGalleryPhotos = <ThrowOnError extends boolean = true>(
  options: Options<NodesGalleryPhotosData, ThrowOnError>,
): RequestResult<NodesGalleryPhotosResponses, NodesGalleryPhotosErrors, ThrowOnError> =>
  (options.client ?? client).get<NodesGalleryPhotosResponses, NodesGalleryPhotosErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/nodes/{node}/gallery-photos",
    ...options,
  });

export const nodesLineSummary = <ThrowOnError extends boolean = true>(
  options: Options<NodesLineSummaryData, ThrowOnError>,
): RequestResult<NodesLineSummaryResponses, NodesLineSummaryErrors, ThrowOnError> =>
  (options.client ?? client).get<NodesLineSummaryResponses, NodesLineSummaryErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/nodes/{node}/line-summary",
    ...options,
  });

export const nodesLineageSplicePreview = <ThrowOnError extends boolean = true>(
  options: Options<NodesLineageSplicePreviewData, ThrowOnError>,
): RequestResult<NodesLineageSplicePreviewResponses, NodesLineageSplicePreviewErrors, ThrowOnError> =>
  (options.client ?? client).get<NodesLineageSplicePreviewResponses, NodesLineageSplicePreviewErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/nodes/{node}/lineage-splice-preview",
    ...options,
  });

export const nodesOrder = <ThrowOnError extends boolean = true>(
  options: Options<NodesOrderData, ThrowOnError>,
): RequestResult<NodesOrderResponses, NodesOrderErrors, ThrowOnError> =>
  (options.client ?? client).post<NodesOrderResponses, NodesOrderErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/nodes/{node}/order",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const nodePackageOffersExposuresStore = <ThrowOnError extends boolean = true>(
  options: Options<NodePackageOffersExposuresStoreData, ThrowOnError>,
): RequestResult<NodePackageOffersExposuresStoreResponses, NodePackageOffersExposuresStoreErrors, ThrowOnError> =>
  (options.client ?? client).post<
    NodePackageOffersExposuresStoreResponses,
    NodePackageOffersExposuresStoreErrors,
    ThrowOnError
  >({ url: "/user/node-package-offers/{offerId}/exposures", ...options });

export const relationshipsIndex = <ThrowOnError extends boolean = true>(
  options: Options<RelationshipsIndexData, ThrowOnError>,
): RequestResult<RelationshipsIndexResponses, RelationshipsIndexErrors, ThrowOnError> =>
  (options.client ?? client).get<RelationshipsIndexResponses, RelationshipsIndexErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/relationships/{node}",
    ...options,
  });

export const nodesMakeRootPreview = <ThrowOnError extends boolean = true>(
  options: Options<NodesMakeRootPreviewData, ThrowOnError>,
): RequestResult<NodesMakeRootPreviewResponses, NodesMakeRootPreviewErrors, ThrowOnError> =>
  (options.client ?? client).get<NodesMakeRootPreviewResponses, NodesMakeRootPreviewErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/nodes/{node}/make-root-preview",
    ...options,
  });

export const nodesSearchExplained = <ThrowOnError extends boolean = true>(
  options: Options<NodesSearchExplainedData, ThrowOnError>,
): RequestResult<NodesSearchExplainedResponses, NodesSearchExplainedErrors, ThrowOnError> =>
  (options.client ?? client).get<NodesSearchExplainedResponses, NodesSearchExplainedErrors, ThrowOnError>({
    responseType: "json",
    url: "/nodes/user/search-explained",
    ...options,
  });

export const branchesNodesStyle = <ThrowOnError extends boolean = true>(
  options: Options<BranchesNodesStyleData, ThrowOnError>,
): RequestResult<BranchesNodesStyleResponses, BranchesNodesStyleErrors, ThrowOnError> =>
  (options.client ?? client).put<BranchesNodesStyleResponses, BranchesNodesStyleErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/nodes/{node}/style",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const notificationCampaignsRecipientsCount = <ThrowOnError extends boolean = true>(
  options: Options<NotificationCampaignsRecipientsCountData, ThrowOnError>,
): RequestResult<
  NotificationCampaignsRecipientsCountResponses,
  NotificationCampaignsRecipientsCountErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    NotificationCampaignsRecipientsCountResponses,
    NotificationCampaignsRecipientsCountErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/user/notification-campaigns/recipients-count",
    ...options,
  });

export const notificationsFeed = <ThrowOnError extends boolean = true>(
  options?: Options<NotificationsFeedData, ThrowOnError>,
): RequestResult<NotificationsFeedResponses, NotificationsFeedErrors, ThrowOnError> =>
  (options?.client ?? client).get<NotificationsFeedResponses, NotificationsFeedErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/notifications/feed",
    ...options,
  });

export const notificationsMarkAllRead = <ThrowOnError extends boolean = true>(
  options?: Options<NotificationsMarkAllReadData, ThrowOnError>,
): RequestResult<NotificationsMarkAllReadResponses, NotificationsMarkAllReadErrors, ThrowOnError> =>
  (options?.client ?? client).post<NotificationsMarkAllReadResponses, NotificationsMarkAllReadErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/notifications/mark-all-read",
    ...options,
  });

export const notificationsRead = <ThrowOnError extends boolean = true>(
  options: Options<NotificationsReadData, ThrowOnError>,
): RequestResult<NotificationsReadResponses, NotificationsReadErrors, ThrowOnError> =>
  (options.client ?? client).put<NotificationsReadResponses, NotificationsReadErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/notifications/{notification}/read",
    ...options,
  });

export const notificationsUnreadCount = <ThrowOnError extends boolean = true>(
  options?: Options<NotificationsUnreadCountData, ThrowOnError>,
): RequestResult<NotificationsUnreadCountResponses, NotificationsUnreadCountErrors, ThrowOnError> =>
  (options?.client ?? client).get<NotificationsUnreadCountResponses, NotificationsUnreadCountErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/notifications/unread-count",
    ...options,
  });

export const nodesOtherParentChildren = <ThrowOnError extends boolean = true>(
  options: Options<NodesOtherParentChildrenData, ThrowOnError>,
): RequestResult<NodesOtherParentChildrenResponses, NodesOtherParentChildrenErrors, ThrowOnError> =>
  (options.client ?? client).get<NodesOtherParentChildrenResponses, NodesOtherParentChildrenErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/nodes/{node}/other-parent-children",
    ...options,
  });

export const pendingRequestsCount = <ThrowOnError extends boolean = true>(
  options?: Options<PendingRequestsCountData, ThrowOnError>,
): RequestResult<PendingRequestsCountResponses, PendingRequestsCountErrors, ThrowOnError> =>
  (options?.client ?? client).get<PendingRequestsCountResponses, PendingRequestsCountErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/api/pending-requests-count",
    ...options,
  });

export const userInvitesResend = <ThrowOnError extends boolean = true>(
  options: Options<UserInvitesResendData, ThrowOnError>,
): RequestResult<UserInvitesResendResponses, UserInvitesResendErrors, ThrowOnError> =>
  (options.client ?? client).post<UserInvitesResendResponses, UserInvitesResendErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/user-invites/{userInvite}/resend",
    ...options,
  });

export const mobileSearchTenants = <ThrowOnError extends boolean = true>(
  options?: Options<MobileSearchTenantsData, ThrowOnError>,
): RequestResult<MobileSearchTenantsResponses, MobileSearchTenantsErrors, ThrowOnError> =>
  (options?.client ?? client).get<MobileSearchTenantsResponses, MobileSearchTenantsErrors, ThrowOnError>({
    responseType: "json",
    url: "/api/v1/mobile/tenants/search",
    ...options,
  });

export const activationChecklistShow = <ThrowOnError extends boolean = true>(
  options?: Options<ActivationChecklistShowData, ThrowOnError>,
): RequestResult<ActivationChecklistShowResponses, ActivationChecklistShowErrors, ThrowOnError> =>
  (options?.client ?? client).get<ActivationChecklistShowResponses, ActivationChecklistShowErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/activation-checklist",
    ...options,
  });

export const statisticsPeople = <ThrowOnError extends boolean = true>(
  options?: Options<StatisticsPeopleData, ThrowOnError>,
): RequestResult<StatisticsPeopleResponses, StatisticsPeopleErrors, ThrowOnError> =>
  (options?.client ?? client).get<StatisticsPeopleResponses, StatisticsPeopleErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/statistics/people",
    ...options,
  });

export const familyLinkSharesStore = <ThrowOnError extends boolean = true>(
  options?: Options<FamilyLinkSharesStoreData, ThrowOnError>,
): RequestResult<FamilyLinkSharesStoreResponses, FamilyLinkSharesStoreErrors, ThrowOnError> =>
  (options?.client ?? client).post<FamilyLinkSharesStoreResponses, FamilyLinkSharesStoreErrors, ThrowOnError>({
    url: "/user/family-link-shares",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

export const testimonialShow = <ThrowOnError extends boolean = true>(
  options?: Options<TestimonialShowData, ThrowOnError>,
): RequestResult<TestimonialShowResponses, TestimonialShowErrors, ThrowOnError> =>
  (options?.client ?? client).get<TestimonialShowResponses, TestimonialShowErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/testimonial",
    ...options,
  });

export const testimonialsStore = <ThrowOnError extends boolean = true>(
  options: Options<TestimonialsStoreData, ThrowOnError>,
): RequestResult<TestimonialsStoreResponses, TestimonialsStoreErrors, ThrowOnError> =>
  (options.client ?? client).post<TestimonialsStoreResponses, TestimonialsStoreErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/testimonials",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const testimonialAsksDestroy = <ThrowOnError extends boolean = true>(
  options: Options<TestimonialAsksDestroyData, ThrowOnError>,
): RequestResult<TestimonialAsksDestroyResponses, TestimonialAsksDestroyErrors, ThrowOnError> =>
  (options.client ?? client).delete<TestimonialAsksDestroyResponses, TestimonialAsksDestroyErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/testimonial-asks/{moment}",
    ...options,
  });

export const testimonialAsksStore = <ThrowOnError extends boolean = true>(
  options: Options<TestimonialAsksStoreData, ThrowOnError>,
): RequestResult<TestimonialAsksStoreResponses, TestimonialAsksStoreErrors, ThrowOnError> =>
  (options.client ?? client).post<TestimonialAsksStoreResponses, TestimonialAsksStoreErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/testimonial-asks/{moment}",
    ...options,
  });

export const testimonialWithdrawalDestroy = <ThrowOnError extends boolean = true>(
  options?: Options<TestimonialWithdrawalDestroyData, ThrowOnError>,
): RequestResult<TestimonialWithdrawalDestroyResponses, TestimonialWithdrawalDestroyErrors, ThrowOnError> =>
  (options?.client ?? client).delete<
    TestimonialWithdrawalDestroyResponses,
    TestimonialWithdrawalDestroyErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/user/testimonial/withdrawal",
    ...options,
  });

export const testimonialWithdrawalStore = <ThrowOnError extends boolean = true>(
  options?: Options<TestimonialWithdrawalStoreData, ThrowOnError>,
): RequestResult<TestimonialWithdrawalStoreResponses, TestimonialWithdrawalStoreErrors, ThrowOnError> =>
  (options?.client ?? client).post<TestimonialWithdrawalStoreResponses, TestimonialWithdrawalStoreErrors, ThrowOnError>(
    {
      responseType: "json",
      url: "/user/testimonial/withdrawal",
      ...options,
    },
  );

export const distributionChart = <ThrowOnError extends boolean = true>(
  options?: Options<DistributionChartData, ThrowOnError>,
): RequestResult<DistributionChartResponses, DistributionChartErrors, ThrowOnError> =>
  (options?.client ?? client).get<DistributionChartResponses, DistributionChartErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/distribution/chart",
    ...options,
  });

export const treePdfExportStart = <ThrowOnError extends boolean = true>(
  options?: Options<TreePdfExportStartData, ThrowOnError>,
): RequestResult<TreePdfExportStartResponses, TreePdfExportStartErrors, ThrowOnError> =>
  (options?.client ?? client).post<TreePdfExportStartResponses, TreePdfExportStartErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/tree-pdf-export/start",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

export const treePdfExportStatus = <ThrowOnError extends boolean = true>(
  options: Options<TreePdfExportStatusData, ThrowOnError>,
): RequestResult<TreePdfExportStatusResponses, TreePdfExportStatusErrors, ThrowOnError> =>
  (options.client ?? client).get<TreePdfExportStatusResponses, TreePdfExportStatusErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/tree-pdf-export/status/{jobId}",
    ...options,
  });

export const userInvitesIndex = <ThrowOnError extends boolean = true>(
  options?: Options<UserInvitesIndexData, ThrowOnError>,
): RequestResult<UserInvitesIndexResponses, UserInvitesIndexErrors, ThrowOnError> =>
  (options?.client ?? client).get<UserInvitesIndexResponses, UserInvitesIndexErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/user-invites",
    ...options,
  });

export const userInvitesStore = <ThrowOnError extends boolean = true>(
  options?: Options<UserInvitesStoreData, ThrowOnError>,
): RequestResult<UserInvitesStoreResponses, UserInvitesStoreErrors, ThrowOnError> =>
  (options?.client ?? client).post<UserInvitesStoreResponses, UserInvitesStoreErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/user-invites",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

export const userInvitesDestroy = <ThrowOnError extends boolean = true>(
  options: Options<UserInvitesDestroyData, ThrowOnError>,
): RequestResult<UserInvitesDestroyResponses, UserInvitesDestroyErrors, ThrowOnError> =>
  (options.client ?? client).delete<UserInvitesDestroyResponses, UserInvitesDestroyErrors, ThrowOnError>({
    responseType: "json",
    url: "/user/user-invites/{userInvite}",
    ...options,
  });
